import styled from 'styled-components';

import type { Rarity } from '__generated__/globalTypes';
import { CollectionStar } from 'atoms/icons/CollectionStar';
import { Horizontal } from 'atoms/layout/flex';
import { LabelL } from 'atoms/typography';
import { getRarityColor } from 'lib/colors';
import type { Color } from 'style/types';

const Wrapper = styled(Horizontal)`
  display: inline-flex;
`;

type Props = {
  score: number;
  suffix?: string | null;
  color?: Color;
  rarity?: Nullable<Rarity>;
};

export const Score = ({ score, suffix, color, rarity }: Props) => {
  const starColor = rarity ? getRarityColor(rarity) : color;

  return (
    <Wrapper as="span" gap={0.5}>
      <CollectionStar color={starColor} size={2} />
      <LabelL bold color={color}>
        {score}
        {suffix}
      </LabelL>
    </Wrapper>
  );
};
